import { Dispatch, FC, SetStateAction, useCallback, useEffect, useState } from "react";
import { InfoList } from "react-migration/components/InfoList";
import { RecordType } from "../../../typings/Record";
import Feature from "src/js/stores/user/Feature";
import { ComparablesList } from "react-migration/domains/comparables/components/Results/ComparablesList";
import hasBetaFeature from "src/js/stores/user/actions/hasBetaFeature";
import { logEventV2, WorkbenchEventName } from "react-migration/lib/util/logEventV2";
import hasFeature from "src/js/stores/user/actions/hasFeature";

export enum TransactionsAccordionStates {
  INCLUDED = "includedResults",
  EXCLUDED = "excludedResults",
  CLOSED = "",
}

export interface TransactionsProps {
  accordionState: TransactionsAccordionStates;
  setAccordionState: Dispatch<SetStateAction<TransactionsAccordionStates>>;
  includedResults: RecordType[];
  loading?: boolean;
  setSelectedRecord: (record: RecordType) => void;
}

export const Transactions: FC<TransactionsProps> = ({ includedResults, setSelectedRecord, loading }) => {
  const [showLoader, setShowLoader] = useState(loading);

  useEffect(() => {
    let timeout: NodeJS.Timeout;

    if (loading && !showLoader) {
      timeout = setTimeout(() => setShowLoader(true), 600);
    }

    return () => {
      if (loading) {
        setShowLoader(false);
      }

      clearTimeout(timeout);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading]);

  const handleSelectRecord = useCallback(
    (transaction: RecordType) => {
      setSelectedRecord(transaction);
      logEventV2({
        name: WorkbenchEventName.WORKBENCH_CARD_CLICK,
        properties: {
          cardName: "comparables",
          action: "goTo",
          uprn: transaction.uprn,
          clickDetail: transaction.address,
          compsHometrackEnabled: hasBetaFeature(Feature.hometrackv2) || hasFeature(Feature.zooplaFullAccess),
        },
      });
    },
    [setSelectedRecord]
  );

  return (
    <InfoList className="m-2 mt-0" data-testid="transactions">
      <ComparablesList includedResults={includedResults} setSelectedRecord={handleSelectRecord} />
    </InfoList>
  );
};
